import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import info from '../../../assets/images/icons/info.svg';
import FilterRadioButton from '../../../components/FilterRadioButtons';
import { FilterRadioButtonsContainer } from '../../../components/FilterRadioButtonsContainer';
import FormGroup from '../../../components/FormGroup';
import Input from '../../../components/Input';
import MyModal from '../../../components/Modal';
import { GetErrorMessageByFieldNameType } from '../../../hooks/useErrors';
import formatCnpj from '../../../utils/formatCnpj';

interface EditModalInterface {
  editCompanyModalShow: boolean;
  companyName: string;
  handleCompanyNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  fantasyName: string;
  handleFantasyNameChange: (event: ChangeEvent<HTMLInputElement>) => void;
  cnpjPagto: string;
  handleCnpjPagtoChange: (event: ChangeEvent<HTMLInputElement>) => void;
  pagadorNFSeparada: boolean;
  setPagadorNFSeparada: Dispatch<SetStateAction<boolean>>;
  cnpjCorretoOriginal?: string;
  companyPhone: string;
  handleCompanyPhoneChange: (event: ChangeEvent<HTMLInputElement>) => void;
  employeesQty: number | string;
  handleEmployeesQtyChange: (event: ChangeEvent<HTMLInputElement>) => void;
  getErrorMessageByFieldName: GetErrorMessageByFieldNameType;
  setEditCompanyModalShow: Dispatch<SetStateAction<boolean>>;
  editCompany: () => void;
  isReadyToEdit: boolean;
}

export default function EditModal({
  editCompanyModalShow,
  companyName,
  handleCompanyNameChange,
  fantasyName,
  handleFantasyNameChange,
  cnpjPagto,
  handleCnpjPagtoChange,
  pagadorNFSeparada,
  setPagadorNFSeparada,
  cnpjCorretoOriginal,
  companyPhone,
  handleCompanyPhoneChange,
  employeesQty,
  handleEmployeesQtyChange,
  getErrorMessageByFieldName,
  setEditCompanyModalShow,
  editCompany,
  isReadyToEdit,
}: EditModalInterface) {
  return (
    <MyModal
      show={editCompanyModalShow}
      title="Editar dados da empresa"
      modalBody={(
        <>
          <FormGroup error={getErrorMessageByFieldName('companyName')}>
            <label htmlFor="companyName">Razão social</label>
            <Input
              id="companyName"
              placeholder="Razão social da empresa"
              value={companyName}
              onChange={handleCompanyNameChange}
              autoComplete="new-password"
              darkBorder
              error={getErrorMessageByFieldName('companyName')}
              maxLength={255}
            />
          </FormGroup>
          <FormGroup error={getErrorMessageByFieldName('fantasyName')}>
            <label htmlFor="fantasyName">Nome fantasia</label>
            <Input
              id="fantasyName"
              placeholder="Nome fantasia da empresa"
              value={fantasyName}
              onChange={handleFantasyNameChange}
              autoComplete="new-password"
              darkBorder
              error={getErrorMessageByFieldName('fantasyName')}
              maxLength={100}
            />
          </FormGroup>
          <FormGroup error={getErrorMessageByFieldName('cnpjPagto')}>
            <label htmlFor="cnpjPagto">CNPJ de pagamento / NF</label>
            <Input
              id="cnpjPagto"
              placeholder="Informe se diferente do CNPJ da empresa"
              value={cnpjPagto}
              onChange={handleCnpjPagtoChange}
              autoComplete="new-password"
              darkBorder
              error={getErrorMessageByFieldName('cnpjPagto')}
              maxLength={20}
            />
          </FormGroup>
          <FormGroup>
            <label>
              Nota Fiscal do CNPJ Pagador Separada?
              {' '}
              <img
                src={info}
                alt="info"
                title="Se o valor do serviço será cobrado em uma nota fiscal do CNPJ PAGADOR, porém separada (Padrão: Não - o valor do serviço será cobrado em uma única nota fiscal pelo CNPJ do pagador)"
                style={{ width: '14px', height: '14px', cursor: 'pointer', verticalAlign: 'middle' }}
              />
            </label>
            <FilterRadioButtonsContainer>
              <FilterRadioButton
                selected={pagadorNFSeparada}
                onClick={() => setPagadorNFSeparada(true)}
              >
                Sim
              </FilterRadioButton>
              <FilterRadioButton
                selected={!pagadorNFSeparada}
                onClick={() => setPagadorNFSeparada(false)}
              >
                Não
              </FilterRadioButton>
            </FilterRadioButtonsContainer>
          </FormGroup>
          {cnpjCorretoOriginal && (
            <FormGroup>
              <label htmlFor="cnpjCorretoOriginal">CNPJ Correto Original (somente informativo)</label>
              <Input
                id="cnpjCorretoOriginal"
                value={formatCnpj(cnpjCorretoOriginal)}
                disabled
                readOnly
                darkBorder
              />
            </FormGroup>
          )}
          <FormGroup error={getErrorMessageByFieldName('companyCellphone')}>
            <label htmlFor="companyPhone">Telefone</label>
            <Input
              id="companyPhone"
              placeholder="Telefone da empresa"
              value={companyPhone}
              onChange={handleCompanyPhoneChange}
              autoComplete="new-password"
              darkBorder
              error={getErrorMessageByFieldName('companyCellphone')}
            />
          </FormGroup>
          <FormGroup error={getErrorMessageByFieldName('employeesQty')}>
            <label htmlFor="employeesQty">Quantidade de funcionários</label>
            <Input
              id="employeesQty"
              placeholder="Quantidade de funcionários"
              value={employeesQty}
              onChange={handleEmployeesQtyChange}
              autoComplete="new-password"
              darkBorder
              error={getErrorMessageByFieldName('employeesQty')}
            />
          </FormGroup>
        </>
      )}
      closeButtonLabel="Fechar"
      actionButtonLabel="Confirmar"
      onClose={() => setEditCompanyModalShow(false)}
      onAction={() => editCompany()}
      isActionButtonDisabled={!isReadyToEdit}
      type="action"
    />
  );
}
